/** Canonical origin for public apply / posting URLs. */
export const APPLY_PUBLIC_ORIGIN = 'https://apply.hiromatch.com';

/** Recruiter marketing app origin. */
export const RECRUITER_SITE_ORIGIN = 'https://hiromatch.com';

/** Runtime site origin for SEO canonical/OG (same build on hiromatch.com + apply.hiromatch.com). */
export function resolveSiteOrigin(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'apply.hiromatch.com') return APPLY_PUBLIC_ORIGIN;
  }
  return RECRUITER_SITE_ORIGIN;
}
